// Záujem z registrácie (tenants.signup_source.zaujem) pre super admina.
// Povolené hodnoty a text notifikácie sú v backend/src/routes/auth.js.
const LABELS: Record<string, string> = {
  efaktura: 'Chce e-faktúru',
  start: 'Záujem: Štart',
  biznis: 'Záujem: Biznis',
  firma: 'Záujem: Firma+',
};

export function signupInterestLabel(source?: { zaujem?: string } | null): string | null {
  const zaujem = source?.zaujem;
  if (!zaujem) return null;
  return LABELS[zaujem] || `Záujem: ${zaujem}`;
}
